import { EXPAND_DRAW_SHAPE_PANEL } from 'constants/actionTypes';

const initialState = false;

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPAND_DRAW_SHAPE_PANEL:
      return action.bool || initialState;
    default:
      return state;
  }
};
